module.exports = __webpack_public_path__ + "img/light-on.81bddbce.svg";